import StaticPage from '../components/StaticPage';

export default function PrivacyPage() {
  return (
    <StaticPage title="Privacy Policy" updated="June 30, 2026">
      <p>This Privacy Policy explains how Izenious Tech Solutions ("we," "us," "our"), operator of halfprice.ca, collects, uses, and protects your personal information.</p>

      <h2>1. Information We Collect</h2>
      <h3>From diners</h3>
      <ul>
        <li>Email address (required to claim a deal)</li>
        <li>Name and neighbourhood (optional, if you create an account)</li>
      </ul>
      <h3>From restaurants</h3>
      <ul>
        <li>Business name, owner name, email, phone, address</li>
        <li>Payment details — processed securely by Stripe; we never store your credit card number</li>
      </ul>
      <h3>Automatically collected</h3>
      <ul>
        <li>Pages visited, deal views, general usage analytics</li>
        <li>Device/browser type for compatibility purposes</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To generate and deliver your redemption codes by email</li>
        <li>To track loyalty stamps and bonus rewards at participating restaurants</li>
        <li>To process restaurant subscription payments via Stripe</li>
        <li>To send service-related emails (verification, redemption confirmations, billing)</li>
        <li>To occasionally send re-engagement or promotional emails — you can unsubscribe anytime</li>
        <li>To improve the Platform and prevent fraud or abuse</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We do not sell your personal information. We share information only with:</p>
      <ul>
        <li><strong>Stripe</strong> — for payment processing (restaurant subscriptions)</li>
        <li><strong>Resend</strong> — our email delivery provider</li>
        <li><strong>Cloudinary</strong> — for hosting restaurant-uploaded images</li>
        <li><strong>Supabase</strong> — our database hosting provider</li>
        <li>The specific restaurant whose deal you claim (your email, so they can verify your redemption code)</li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>We retain account and transaction data for as long as your account is active or as needed to comply with legal obligations. You may request deletion of your data by contacting us.</p>

      <h2>5. Your Rights</h2>
      <p>You may request access to, correction of, or deletion of your personal information at any time by emailing <a href="mailto:hello@halfprice.ca">hello@halfprice.ca</a>. Every promotional email includes an unsubscribe link.</p>

      <h2>6. Cookies</h2>
      <p>We use minimal cookies/local storage strictly necessary for login sessions and basic site functionality. We do not use third-party advertising trackers.</p>

      <h2>7. Security</h2>
      <p>We use industry-standard measures (encrypted connections, hashed passwords, secure payment processing via Stripe) to protect your data. No system is 100% secure, and we cannot guarantee absolute security.</p>

      <h2>8. Children's Privacy</h2>
      <p>halfprice.ca is not directed at children under 13. We do not knowingly collect personal information from children.</p>

      <h2>9. Changes to This Policy</h2>
      <p>We may update this Privacy Policy periodically. Material changes will be reflected with an updated "Last updated" date above.</p>

      <h2>10. Contact</h2>
      <p>Questions about this policy? Contact us at <a href="mailto:hello@halfprice.ca">hello@halfprice.ca</a>.</p>
    </StaticPage>
  );
}
